<template>
  <div class="w-scale">
    <transition name="mask">
      <div class="mask" v-show="scaleShow" @click="handleClose" @touchmove.prevent></div>
    </transition>
    <transition name="fade">
      <div class="w-scale-content" v-show="scaleShow" :style="{top: `${top}%`}">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    scaleShow: {
      type: Boolean,
      default: false
    },
    top: {
      type: [String, Number],
      default: 15
    }
  },
  data () {
    return {}
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    handleClose () {
      this.$emit('handleClose')
    }
  }
}
</script>
<style scoped lang="scss">
.w-scale {
  display: flex;
  justify-content: center;
  .mask-enter-active,
  .mask-leave-active {
    transition: all 0.3s;
  }
  .mask-enter,
  .mask-leave-to {
    opacity: 1;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2001;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    transform: scale(0)
  }

  .w-scale-content {
    position: fixed;
    top: 15%;
    // left: 50%;
    // transform: translateX(-50%);
    z-index: 2009;
  }
}
</style>
